import { render, staticRenderFns } from "./deployAppoint.vue?vue&type=template&id=80e4984a&scoped=true&"
import script from "./deployAppoint.vue?vue&type=script&lang=js&"
export * from "./deployAppoint.vue?vue&type=script&lang=js&"
import style0 from "./deployAppoint.vue?vue&type=style&index=0&id=80e4984a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e4984a",
  null
  
)

export default component.exports